import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const HorizontalSlider = ({ product }) => {
  // Slider settings
  const settings = {
    dots: false,
    lazyLoad: 'ondemand',
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: false,
  };
  // Extract image URLs from the product prop
  const images = [
    { image: product?.product_main_image_url_large },
    { image: product?.product_image_two_url },
    { image: product?.product_image_three_url },
    { image: product?.product_image_four_url },
  ];

  return (
    <div style={{ width: "84%", margin: "auto" }} className="horizontal-slider">
      <Slider {...settings}>
        {images.map((item, index) => (
          <div key={index}>
            <div
              style={{
                height: "100%",
              
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
               
                fontSize: "24px",
              }}
            >
              <img
                src={item.image}
                alt="img"
                className="img-fluid"
                loading="lazy"
                style={{
                  height: "100%",
                }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};




export default HorizontalSlider;
